import styled, { css } from 'styled-components';
import { NoImage } from '../HubContentViewer/styles';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const LoopHeaderSection = styled.section`
  padding: 0 20px;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  color: ${({ theme }) => theme.colors.white_7};
  font-size: 15px;

  fieldset > div:first-of-type {
    justify-content: flex-end;
    margin-bottom: 20px;

    div {
      background-size: 16px;
      height: 16px;
      width: 16px;
      margin: 0px 0px 0px 20px;
    }
  }

  .italic {
    font-style: italic;
  }

  .content-section iframe {
    max-width: 337px;

    .lp--fullScreenPanel & {
      max-width: initial;
    }
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
`;

export const FieldSet = styled.fieldset`
  border: 1px solid ${({ theme }) => theme.colors.white_2};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.white_7};
  margin-bottom: 40px;
  padding: 20px;
  width: 100%;

  *:last-of-type {
    margin-bottom: 0px;
  }
`;

export const FieldSetLabel = styled.legend`
  all: unset;
  padding: 0 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 33px;

  .hub & {
    height: 56px;
  }
`;

export const LoopTopSection = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  justify-content: ${({ collapsedDescription }) => (!collapsedDescription ? 'flex-end' : 'space-between')};
  padding: 13px 16px;
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 3;
`;

export const ClosePanelIcon = styled.button`
  opacity: 0.6;
  transition: 0.2s opacity ease;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.transparent};
  display: block;
  cursor: pointer;
  background-size: 18px 18px;
  height: 18px;
  width: 18px;
  margin: 0 0 0 25px;
  border: none;
  outline: none;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const LinkButton = styled.button`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.transparent};
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  border: none;
  outline: none;
  white-space: nowrap;
  padding: 0;

  &.share-icon {
    background-image: url('/assets/images/tmp/v2/icons/shareIcon.png');
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
    width: 32px;
  }

  &.share-link {
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
  }

  &.curriculum-icon {
    background-image: url('/assets/images/theme-2/icons/curriculum.svg');
    width: 32px;
    background-size: contain;
  }
`;

export const List = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0px 0px 17px 0px;
  padding: 0px;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white_7};
`;

export const Delimiter = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.defaultPlaceholder};
  height: 5px;
  margin-left: 36px;

  &.hub {
    height: 12px;
  }

  &:has(+ .hub) {
    height: 16px;
  }

  &.hub:last-of-type,
  &.node:last-of-type {
    display: none;
  }
`;

export const NodeList = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: 15px;
`;

export const NodeListItem = styled.li`
  background-position: 0;
  background-repeat: no-repeat;
  background-size: 15px auto;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 26px;
  min-height: 20px;
  padding-left: 37px;
  position: relative;
  color: ${({ theme }) => theme.colors.hoverGrey};
  background-color: ${({ theme }) => theme.colors.standardBlackBackground};
  border: 1px solid ${({ theme }) => theme.colors.menuButtonBorder};
  border-radius: 6px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease;

  &.hub {
    background-color: ${({ theme }) => theme.colors.standardComponentBackground};
  }

  &:hover,
  &:focus {
    opacity: 1;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.standardComponentBackground};
    transition:
      color 0.2s ease,
      background-color 0.2s ease;

    &.hub {
      background-color: ${({ theme }) => theme.colors.white_1};
    }
  }

  &.hub {
    font-size: 18px;
    font-weight: 700;
    height: 100%;
    margin: 0;
    min-height: 74px;
    padding: 10px;

    &.done img,
    &.done ${NoImage} {
      opacity: 0.5;
      background-color: ${({ theme }) => theme.colors.black_9};
      border: 2px solid ${({ theme }) => theme.colors.menuButtonBorder};
    }

    &.locked,
    &.code {
      &::after {
        content: ' ';
        position: absolute;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-size: 56px;
        background-position: center center;
        transform: translate(-3px);
      }
    }

    &.locked::after {
      background-image: url('/assets/images/theme-2/icons/graph/node-locked.png');
    }

    &.code::after {
      background-image: url('/assets/images/theme-2/icons/graph/node-passwd-protected.png');
    }
  }

  &.node {
    font-size: 16px;
    justify-content: space-between;
    margin: 0;
    min-height: 56px;
    padding: 9px 0 9px 68px;

    &:before {
      background-color: ${({ theme }) => theme.colors.black};
      background-position: 9px;
      background-repeat: no-repeat;
      border: 2px solid ${({ theme }) => theme.colors.transparent};
      border-radius: 50%;
      content: '';
      height: 33px;
      margin: 0 0 0 -50px;
      position: absolute;
      width: 33px;
    }

    &.done:before {
      border-color: ${({ theme }) => theme.colors.menuButtonBorder} !important;
    }

    &.chunk {
      &:before {
        background-image: url('/assets/images/theme-2/icons/subcat.svg');
        background-position: 8px;
        background-size: 15px auto;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/subcat.svg');
      }
    }

    &.video {
      &:before {
        background-image: url('/assets/images/theme-2/icons/video.svg');
        background-size: 10px auto;
        background-position: 11px 7px;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/video.svg');
      }
    }

    &.link {
      &:before {
        background-image: url('/assets/images/theme-2/icons/link.svg');
        background-size: 15px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/link.svg');
      }
    }

    &.legend {
      &:before {
        background-image: url('/assets/images/theme-2/icons/concept.svg');
        background-size: 10px auto;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/concept.svg');
      }
    }

    &.correlation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/correlation.svg');
        background-size: 15px auto;
        background-position: 7px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/correlation.svg');
      }
    }

    &.correlation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/correlation.svg');
        background-size: 15px auto;
        background-position: 7px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/correlation.svg');
      }
    }

    &.checklist {
      &:before {
        background-image: url('/assets/images/theme-2/icons/checklist.svg');
        background-size: 60%;
        background-position: center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/checklist.svg');
      }
    }

    &.quiz {
      &:before {
        background-image: url('/assets/images/theme-2/icons/quiz.svg');
        background-size: 19px auto;
        background-position: 5px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/quiz.svg');
      }
    }

    &.task {
      &:before {
        background-image: url('/assets/images/theme-2/icons/default.svg');
        background-size: 8px auto;
        background-position: 11px center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/default.svg');
      }
    }

    &.group {
      &:before {
        background-image: url('/assets/images/theme-2/icons/connected.svg');
        background-size: 15px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorGreen};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/connected.svg');
      }
    }

    &.evaluation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/evaluation.svg');
        background-size: 10px auto;
        border-color: ${({ theme }) => theme.colors.behaviorPurple};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/evaluation.svg');
      }
    }

    &.private_blog {
      &:before {
        background-image: url('/assets/images/theme-2/icons/logbook.svg');
        background-size: 13px auto;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/logbook.svg');
      }
    }

    &.written_quiz {
      &:before {
        background-image: url('/assets/images/theme-2/icons/written_quiz.svg');
        background-size: 9px auto;
        background-position: 10px center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/written_quiz.svg');
      }
    }

    &.public_blog {
      &:before {
        background-image: url('/assets/images/theme-2/icons/noticeboard.svg');
        background-size: 14px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorGreen};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/noticeboard.svg');
      }
    }
  }
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const UserImage = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const UserName = styled.span`
  font-size: 14px;
`;

export const Categories = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Category = styled.span`
  background-color: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  margin: 0;
  padding: 0;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &.grade-1-3 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorPinkFront};
  }

  &.grade-4-6 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorBlueFront};
  }

  &.grade-7-9 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
  }

  &.grade-teacher {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorPurpleFront};
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  margin: 20px;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 16px;

  &.link {
    opacity: 0.8;
    transition: opacity 0.2s ease;

    &:hover,
    &:focus {
      opacity: 1;
      transition: opacity 0.2s ease;
    }
  }
`;

export const Cell1 = styled.div`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  width: 32px;
  margin-right: 30px;
`;

export const Cell2 = styled.div`
  display: flex;
  white-space: nowrap;
`;

export const CollapsedDescription = styled.div`
  color: ${({ theme }) => theme.colors.hoverGrey};
  border: 1px solid ${({ theme }) => theme.colors.menuButtonBorder};
  border-radius: 6px;
  cursor: pointer;
  display: block;
  padding: 5px 10px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.standardComponentBackground};
    color: ${({ theme }) => theme.colors.white};
    transition:
      color 0.2s ease,
      background-color 0.2s ease;
  }
`;

export const ProgressPanel = styled.div`
  margin-bottom: 16px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProgressIndicator = styled.div`
  width: 100%;
  margin: 0 3px 0 7px;
  height: 8px;
  background: ${({ theme }) => theme.colors.defaultPlaceholder};
  border-radius: 4px;

  &:first-of-type {
    margin-left: 0;
  }
`;

export const Progress = styled.div`
  height: 8px;
  border-radius: 4px;
  transition: 0.5s;
  width: ${({ value }) => `${value}%`};

  &.yellow {
    background-color: ${({ theme }) => theme.colors.behaviorYellow};
  }

  &.green {
    background-color: ${({ theme }) => theme.colors.behaviorGreen};
  }

  &.blue {
    background-color: ${({ theme }) => theme.colors.behaviorBlue};
  }

  &.pink {
    background-color: ${({ theme }) => theme.colors.behaviorPink};
  }

  &.purple {
    background-color: ${({ theme }) => theme.colors.behaviorPurple};
  }
`;

export const ProgressText = styled.div`
  font-size: 12px;
  font-weight: bold;

  &.yellow {
    color: ${({ theme }) => theme.colors.behaviorYellowFront};
  }

  &.green {
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
  }

  &.blue {
    color: ${({ theme }) => theme.colors.behaviorBlueFront};
  }

  &.pink {
    color: ${({ theme }) => theme.colors.behaviorPinkFront};
  }

  &.purple {
    color: ${({ theme }) => theme.colors.behaviorPurpleFront};
  }
`;

export const Hidden = styled.div`
  display: none;
`;
